/* ── GRID SWITCHER ── */
function ncSetGrid(cols) {
  var grid = document.getElementById('ncGrid');
  grid.className = 'nc-product-grid cols-' + cols;
  document.querySelectorAll('.nc-grid-btn').forEach(function(b) { b.classList.remove('active'); });
  document.getElementById('btn-' + cols).classList.add('active');
  localStorage.setItem('nc-grid-cols', cols);
}

/* Restore saved grid preference */
(function() {
  var saved = localStorage.getItem('nc-grid-cols');
  if (saved && ['2','3','4'].includes(saved)) { ncSetGrid(parseInt(saved)); } else { ncSetGrid(4); }
})();

/* ── FILTER TOGGLE ── */
function ncToggleFilter(titleEl) {
  titleEl.classList.toggle('collapsed');
  var body = titleEl.nextElementSibling;
  body.classList.toggle('hidden');
}

/* ── PRICE DISPLAY ── */
function ncUpdatePrice(input) {
  document.getElementById('ncPriceVal').textContent = input.value;
}

/* ── FILTER RESET ── */
function ncResetFilter(type) {
  if (type === 'availability') {
    document.querySelectorAll('input[name="availability"]').forEach(function(c) { c.checked = false; });
  } else if (type === 'category') {
    document.querySelectorAll('input[name="category"]').forEach(function(c) { c.checked = false; });
  } else if (type === 'price') {
    var r = document.getElementById('ncPriceRange');
    r.value = r.max;
    document.getElementById('ncPriceVal').textContent = r.max;
  }
  ncFilterProducts();
}

/* ── MAIN FILTER LOGIC ── */
function ncFilterProducts() {
  var cards = document.querySelectorAll('.nc-card');
  var selectedAvail = Array.from(document.querySelectorAll('input[name="availability"]:checked')).map(function(c){return c.value;});
  var selectedCats = Array.from(document.querySelectorAll('input[name="category"]:checked')).map(function(c){return c.value;});
  var maxPrice = parseFloat(document.getElementById('ncPriceRange').value);
  var visible = 0;

  cards.forEach(function(card) {
    var price = parseFloat(card.dataset.price);
    var available = card.dataset.available === 'true';
    var cats = card.dataset.cats || '';

    var priceOk = price <= maxPrice;

    var availOk = true;
    if (selectedAvail.length > 0) {
      availOk = (selectedAvail.includes('instock') && available) || (selectedAvail.includes('outofstock') && !available);
    }

    var catOk = true;
    if (selectedCats.length > 0) {
      catOk = selectedCats.some(function(sc) { return cats.includes(sc); });
    }

    if (priceOk && availOk && catOk) {
      card.style.display = '';
      visible++;
    } else {
      card.style.display = 'none';
    }
  });

  var countEl = document.getElementById('ncProductCount');
  if (countEl) countEl.textContent = visible + ' product' + (visible !== 1 ? 's' : '');
}

/* ── SORT ── */
function ncSort(val) {
  var url = new URL(window.location.href);
  url.searchParams.set('sort_by', val);
  window.location.href = url.toString();
}


/* ── CART DRAWER FUNCTIONS ── */
function ncOpenCart() {
  document.getElementById('ncCartDrawer').classList.add('open');
  document.getElementById('ncCartOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  ncRefreshCart();
}
function ncCloseCart() {
  document.getElementById('ncCartDrawer').classList.remove('open');
  document.getElementById('ncCartOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

function ncFormatMoney(cents) {
  return (cents / 100).toFixed(2);
}

function ncRefreshCart() {
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart) {
      var itemsEl = document.getElementById('ncCartItems');
      var footerEl = document.getElementById('ncCartFooter');
      var subtotalEl = document.getElementById('ncCartSubtotal');
      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="nc-cart-empty">Your cart is empty.</div>';
        if (footerEl) footerEl.style.display = 'none';
        return;
      }

      if (footerEl) footerEl.style.display = 'block';
      if (subtotalEl) subtotalEl.textContent = cart.currency + ' ' + (cart.total_price / 100).toFixed(2);

      var html = '';
      cart.items.forEach(function(item) {
        var key = item.key;
        var qty = item.quantity;
        html += '<div class="nc-cart-item">';
        html += '<img class="nc-cart-item__img" src="' + item.image + '" alt="">';
        html += '<div class="nc-cart-item__info">';
        html += '<div class="nc-cart-item__title">' + item.product_title + '</div>';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          html += '<div style="font-size:11px;color:#aaa;margin-bottom:4px;">' + item.variant_title + '</div>';
        }
        html += '<div class="nc-cart-item__price">' + cart.currency + ' ' + (item.final_line_price / 100).toFixed(2) + '</div>';
        html += '<div class="nc-cart-item__qty">';
        html += '<button data-key="' + key + '" data-qty="' + (qty - 1) + '" onclick="ncUpdateQty(this.dataset.key, parseInt(this.dataset.qty))">&#8722;</button>';
        html += '<span>' + qty + '</span>';
        html += '<button data-key="' + key + '" data-qty="' + (qty + 1) + '" onclick="ncUpdateQty(this.dataset.key, parseInt(this.dataset.qty))">&#43;</button>';
        html += '</div>';
        html += '</div>';
        html += '<button class="nc-cart-item__remove" data-key="' + key + '" onclick="ncUpdateQty(this.dataset.key, 0)">&#x2715;</button>';
        html += '</div>';
      });
      itemsEl.innerHTML = html;
    })
    .catch(function(e){ console.error('Cart fetch error:', e); });
}


function ncAddToCart(btnEl) {
  var variantId = btnEl.getAttribute('data-variant');
  if (!variantId) return;

  var origText = btnEl.textContent;
  btnEl.textContent = 'Adding...';
  btnEl.disabled = true;

  var formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(function(r) {
    if (!r.ok) throw new Error('Cart add failed');
    return r.json();
  })
  .then(function() {
    btnEl.textContent = 'Added ✓';
    setTimeout(function() {
      btnEl.textContent = origText;
      btnEl.disabled = false;
    }, 1500);
    ncOpenCart();
  })
  .catch(function(err) {
    console.error('ncAddToCart error:', err);
    btnEl.textContent = origText;
    btnEl.disabled = false;
  });
}

function ncUpdateQty(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r){ return r.json(); })
  .then(function() { ncRefreshCart(); });
}

/* Close drawer on Escape */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') ncCloseCart();
});

/* ── WISHLIST ── */
function ncWishlist(btn, productId) {
  btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="#e44" stroke="#e44" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
}

/* ── AVAILABILITY COUNTS ── */
(function() {
  var cards = document.querySelectorAll('.nc-card');
  var instock = 0, outofstock = 0;
  cards.forEach(function(c) {
    if (c.dataset.available === 'true') instock++;
    else outofstock++;
  });
  var i = document.getElementById('count-instock');
  var o = document.getElementById('count-outofstock');
  if (i) i.textContent = '(' + instock + ')';
  if (o) o.textContent = '(' + outofstock + ')';
})();